/**
 * Generated from MovieScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function MovieScreenLayout(this: $MovieScreenLayout) {
	$(this, "main", main, {x:1024, y:768});
	return this;
}
export function main(this: $main) {
	const buttons = this.buttons;
	$(buttons, 0, movieBackgroundButton, {x:-328.5, y:621.1, w:320.00, h: 328.00});
	$(buttons, 1, movieCharacterButton, {x:-3, y:621.1, w:320.00, h: 328.00});
	$(buttons, 2, moviePropButton, {x:322.55, y:621.1, w:320.00, h: 328.00});
	$(this, "background", background, {x:-1664, y:-768, w:3328.80, h: 1536.00});
	$(this, "tvBg", backgroundTv, {x:-1664, y:-768, w:3328.80, h: 1536.00});
	$(this, "assembly", assembly, {x:0, y:0});
	$(this, "tv", assembly, {x:-93.15, y:82.25, sx:1.180, sy:1.180});
	$(this, "camera", movieCamera, {x:-853.25, y:470.75, w:404.00, h: 595.00});
	$(this, "buttonPlay", buttonPlayGreen, {x:229.6, y:596.3, w:349.00, h: 343.00});
	$(this, "buttonBack", buttonHomeGreen, {x:-175.05, y:596.3, w:349.00, h: 343.00});
	return this;
}
function background(this: $background) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-movie.jpg", 0.000, 0.000);
	return this;
}
function backgroundTv(this: $backgroundTv) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-movie-tv.jpg", 0.000, 0.000);
	return this;
}
export function assembly(this: $assembly) {
	const background = this.background;
	$(background, 0, movieBackground1, {x:428.4, y:36.4, w:1609.00, h: 1142.00});
	$(background, 1, movieBackground2, {x:428.4, y:36.4, w:1609.00, h: 1142.00});
	$(background, 2, movieBackground3, {x:-55.6, y:-160.6, w:1609.00, h: 1142.00});
	$(background, 3, movieBackground4, {x:-55.6, y:-160.6, w:1609.00, h: 1142.00});
	$(background, 4, movieBackground5, {x:-55.6, y:-160.6, w:1609.00, h: 1142.00});
	$(background, 5, movieBackground6, {x:-55.6, y:-160.6, w:1609.00, h: 1142.00});
	const prop = this.prop;
	$(prop, 0, movieProp1, {x:391.4, y:-443.9, w:912.00, h: 439.00});
	$(prop, 1, movieProp2, {x:501.4, y:-35.3, w:859.00, h: 951.00});
	$(prop, 2, movieProp3, {x:590.3, y:-40.6, w:513.00, h: 1012.00});
	$(prop, 3, movieProp4, {x:462.2, y:-298.55, w:780.00, h: 853.00});
	$(prop, 4, movieProp5, {x:464.5, y:-83.5, w:966.00, h: 1006.00});
	$(prop, 5, movieProp6, {x:431.95, y:-115.3, w:436.00, h: 1053.00});
	$(prop, 6, movieProp7, {x:396.75, y:54.85, w:985.00, h: 688.00});
	$(prop, 7, movieProp8, {x:452.05, y:96.05, w:1152.00, h: 615.00});
	$(prop, 8, movieProp9, {x:391.7, y:-18.85, w:528.00, h: 858.00});
	const character = this.character;
	$(character, 0, movieLuna1, {x:-176, y:401.2, w:1063.00, h: 827.00});
	$(character, 1, movieLuna2, {x:-176.5, y:401.2, w:937.00, h: 959.00});
	$(character, 2, movieLuna3, {x:-176, y:401.2, w:963.00, h: 849.00});
	$(character, 3, movieAndy1, {x:-176, y:401.2, w:451.00, h: 511.00});
	$(character, 4, movieAndy2, {x:-176, y:401.2, w:272.00, h: 430.00});
	$(character, 5, movieAndy3, {x:-176, y:401.2, w:268.00, h: 430.00});
	$(character, 6, movieCarmen1, {x:-176.5, y:401.2, w:418.00, h: 599.00});
	$(character, 7, movieCarmen2, {x:-176.5, y:401.2, w:402.00, h: 598.00});
	$(character, 8, movieCarmen3, {x:-176, y:401.2, w:427.00, h: 594.00});
	$(character, 9, movieLeo1, {x:-176.5, y:401.2, w:478.00, h: 562.00});
	$(character, 10, movieLeo2, {x:-176.5, y:401.2, w:315.00, h: 512.00});
	$(character, 11, movieLeo3, {x:-176.5, y:401.2, w:344.00, h: 502.00});
	const animal = this.animal;
	$(animal, 0, movieAnimal1, {x:-159.75, y:447.25, w:334.00, h: 849.00});
	$(animal, 1, movieAnimal2, {x:-121.05, y:396.35, w:897.00, h: 899.00});
	$(animal, 2, movieAnimal3, {x:-123.75, y:446.85, w:678.00, h: 635.00});
	$(animal, 3, movieAnimal4, {x:-183.8, y:419.6, w:790.00, h: 1010.00});
	$(this, "tvScreen", movieTv, {x:60.75, y:-153.6, w:1562.23, h: 1342.09});
	$(this, "tvMask", [89.70,-740.35,742.15,-703.95,793.70,-248.50,752.10,352.95,-520.05,396.85,-636.25,-46.25,-649.60,-634.00]);
	return this;
}
function movieBackground1(this: $movieBackground1) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-background-1.png", 0.801, 0.673);
	return this;
}
function movieBackground2(this: $movieBackground2) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-background-2.png", 0.801, 0.673);
	return this;
}
function movieBackground3(this: $movieBackground3) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-background-3.png", 0.500, 0.500);
	return this;
}
function movieBackground4(this: $movieBackground4) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-background-4.png", 0.500, 0.500);
	return this;
}
function movieBackground5(this: $movieBackground5) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-background-5.png", 0.500, 0.500);
	return this;
}
function movieBackground6(this: $movieBackground6) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-background-6.png", 0.500, 0.500);
	return this;
}
function movieProp1(this: $movieProp1) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-1.png", 0.487, 0.497);
	return this;
}
function movieProp2(this: $movieProp2) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-2.png", 0.487, 0.500);
	return this;
}
function movieProp3(this: $movieProp3) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-3.png", 0.815, 0.574);
	return this;
}
function movieProp4(this: $movieProp4) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-4.png", 0.503, 0.505);
	return this;
}
function movieProp5(this: $movieProp5) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-5.png", 0.489, 0.500);
	return this;
}
function movieProp6(this: $movieProp6) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-6.png", 0.472, 0.499);
	return this;
}
function movieProp7(this: $movieProp7) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-7.png", 0.500, 0.500);
	return this;
}
function movieProp8(this: $movieProp8) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-8.png", 0.500, 0.500);
	return this;
}
function movieProp9(this: $movieProp9) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-9.png", 0.500, 0.500);
	return this;
}
function movieLuna1(this: $movieLuna1) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-luna-1.png", 0.492, 0.990);
	return this;
}
function movieLuna2(this: $movieLuna2) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-luna-2.png", 0.492, 0.999);
	return this;
}
function movieLuna3(this: $movieLuna3) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-luna-3.png", 0.493, 0.999);
	return this;
}
function movieAndy1(this: $movieAndy1) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-andy-1.png", 0.488, 0.994);
	return this;
}
function movieAndy2(this: $movieAndy2) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-andy-2.png", 0.478, 1.000);
	return this;
}
function movieAndy3(this: $movieAndy3) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-andy-3.png", 0.478, 1.000);
	return this;
}
function movieCarmen1(this: $movieCarmen1) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-carmen-1.png", 0.481, 1.000);
	return this;
}
function movieCarmen2(this: $movieCarmen2) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-carmen-2.png", 0.483, 1.000);
	return this;
}
function movieCarmen3(this: $movieCarmen3) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-carmen-3.png", 0.482, 1.000);
	return this;
}
function movieLeo1(this: $movieLeo1) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-leo-1.png", 0.487, 1.000);
	return this;
}
function movieLeo2(this: $movieLeo2) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-leo-2.png", 0.483, 1.000);
	return this;
}
function movieLeo3(this: $movieLeo3) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-leo-3.png", 0.500, 0.998);
	return this;
}
function movieAnimal1(this: $movieAnimal1) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-animal-1.png", 0.491, 1.000);
	return this;
}
function movieAnimal2(this: $movieAnimal2) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-animal-2.png", 0.491, 1.000);
	return this;
}
function movieAnimal3(this: $movieAnimal3) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-animal-3.png", 0.484, 1.000);
	return this;
}
function movieAnimal4(this: $movieAnimal4) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-animal-4.png", 0.487, 1.000);
	return this;
}
function movieTv(this: $movieTv) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-tv.png", 0.500, 0.500);
	return this;
}
function tvMask(this: $tvMask) {
	return this;
}
function movieCamera(this: $movieCamera) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-camera.png", 0.500, 0.500);
	return this;
}
function movieCharacterButton(this: $movieCharacterButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-character-button.png", 0.500, 0.500);
	return this;
}
function moviePropButton(this: $moviePropButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-prop-button.png", 0.500, 0.500);
	return this;
}
function movieBackgroundButton(this: $movieBackgroundButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("movie-background-button.png", 0.500, 0.500);
	return this;
}
function buttonPlayGreen(this: $buttonPlayGreen) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-play-green.png", 0.500, 0.500);
	return this;
}
function buttonHomeGreen(this: $buttonHomeGreen) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-home-green.png", 0.500, 0.500);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $MovieScreenLayout {
	readonly main: $main;
}
interface $main extends $$container {
	readonly buttons: $$array<$movieBackgroundButton|$movieCharacterButton|$moviePropButton>;
	readonly background: $background;
	readonly tvBg: $backgroundTv;
	readonly assembly: $assembly;
	readonly tv: $assembly;
	readonly camera: $movieCamera;
	readonly buttonPlay: $buttonPlayGreen;
	readonly buttonBack: $buttonHomeGreen;
}
interface $background extends $$sprite {
}
interface $backgroundTv extends $$sprite {
}
interface $assembly extends $$container {
	readonly background: $$array<$movieBackground1|$movieBackground2|$movieBackground3|$movieBackground4|$movieBackground5|$movieBackground6>;
	readonly prop: $$array<$movieProp1|$movieProp2|$movieProp3|$movieProp4|$movieProp5|$movieProp6|$movieProp7|$movieProp8|$movieProp9>;
	readonly character: $$array<$movieLuna1|$movieLuna2|$movieLuna3|$movieAndy1|$movieAndy2|$movieAndy3|$movieCarmen1|$movieCarmen2|$movieCarmen3|$movieLeo1|$movieLeo2|$movieLeo3>;
	readonly animal: $$array<$movieAnimal1|$movieAnimal2|$movieAnimal3|$movieAnimal4>;
	readonly tvScreen: $movieTv;
	readonly tvMask: $tvMask;
}
interface $movieBackground1 extends $$sprite {
}
interface $movieBackground2 extends $$sprite {
}
interface $movieBackground3 extends $$sprite {
}
interface $movieBackground4 extends $$sprite {
}
interface $movieBackground5 extends $$sprite {
}
interface $movieBackground6 extends $$sprite {
}
interface $movieProp1 extends $$sprite {
}
interface $movieProp2 extends $$sprite {
}
interface $movieProp3 extends $$sprite {
}
interface $movieProp4 extends $$sprite {
}
interface $movieProp5 extends $$sprite {
}
interface $movieProp6 extends $$sprite {
}
interface $movieProp7 extends $$sprite {
}
interface $movieProp8 extends $$sprite {
}
interface $movieProp9 extends $$sprite {
}
interface $movieLuna1 extends $$sprite {
}
interface $movieLuna2 extends $$sprite {
}
interface $movieLuna3 extends $$sprite {
}
interface $movieAndy1 extends $$sprite {
}
interface $movieAndy2 extends $$sprite {
}
interface $movieAndy3 extends $$sprite {
}
interface $movieCarmen1 extends $$sprite {
}
interface $movieCarmen2 extends $$sprite {
}
interface $movieCarmen3 extends $$sprite {
}
interface $movieLeo1 extends $$sprite {
}
interface $movieLeo2 extends $$sprite {
}
interface $movieLeo3 extends $$sprite {
}
interface $movieAnimal1 extends $$sprite {
}
interface $movieAnimal2 extends $$sprite {
}
interface $movieAnimal3 extends $$sprite {
}
interface $movieAnimal4 extends $$sprite {
}
interface $movieTv extends $$sprite {
}
interface $tvMask extends $$polygon {
}
interface $movieCamera extends $$sprite {
}
interface $movieCharacterButton extends $$sprite {
}
interface $moviePropButton extends $$sprite {
}
interface $movieBackgroundButton extends $$sprite {
}
interface $buttonPlayGreen extends $$sprite {
}
interface $buttonHomeGreen extends $$sprite {
}
